// removed by extract-text-webpack-plugin
module.exports = {"wk-dialog-wrap":"wk-dialog-wrap__PCHUi","wk-dialog":"wk-dialog__AcD11","wk-dialog-icon":"wk-dialog-icon__dt4ry","wk-dialog-title":"wk-dialog-title__2BSUZ","wk-dialog-subTitle":"wk-dialog-subTitle__3ylHo","wk-dialog-btnGroup":"wk-dialog-btnGroup__16_qI","wk-dialog-input":"wk-dialog-input__DMF1D","wk-dialog-textarea":"wk-dialog-textarea__21Ks3"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/dialog.common.css
// module id = 447
// module chunks = 3